export const styles = `
  .component-Input-Typeahead {
        width: 100%;
        position: relative;
  }
   .component-Input-Typeahead input {
        background-color: #f3f5f8;
        width: 100%;
        height: 50px;
        border-radius: 0;
        border: none;
        outline: none;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: 14px;
        font-style: italic;
        color: #353535;
        padding: 10px;
  }
   .component-Input-Typeahead input::placeholder {
        color: #353535;
        font-weight: 300;
  }
   .component-Input-Typeahead .suggestion-box {
        max-height: 255px;
        overflow-y: auto;
        padding: 5px 0 0;
        position: absolute;
        width: 100%;
        z-index: 3;
  }
   .component-Input-Typeahead .suggestion-box .suggestion-option {
        background-color: #f2f2f2;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: 13px;
        display: flex;
        align-items: center;
        min-height: 25px;
        padding: 0 5px;
  }
   .component-Input-Typeahead .suggestion-box .suggestion-option.suggestion-active {
        background-color: #2a4473;
        color: #fff;
        -webkit-text-fill-color: #fff;
  }
   .component-Input-Typeahead div.tags-container {
        display: inline-flex;
        flex-wrap: wrap;
        margin: 10px 0 0;
        width: 100%;
  }
  .pac-item-query {
    margin-right:5px;
  }
`;
